import { LSK } from '../utils/storage/config';
import { DeployEnvironment, ENV_CONFIG } from '../../../env.config';
import matrixAssets from '@shared/matrix';

export const DEV_MODE = import.meta.env.DEV;
export const PROD_MODE = import.meta.env.PROD;

export const ENV_MODE = import.meta.env.MODE;

// 线上环境
export const isProd = A1_BUILD_ENV === DeployEnvironment.zprod;

export const isOpenDebugMode =
	!isProd || localStorage.getItem(LSK.OPEN_DEV_TOOL_IN_PROD) === 'true';

export const isOpenWebDebugMode = localStorage.getItem(LSK.OPEN_WEB_DEV_TOOL) === 'true';

/** 支持 LOGGER 的环境即 开发、测试环境 */
export const LOGGER_ENABLE =
	DEV_MODE || [DeployEnvironment.tencent].includes(A1_BUILD_ENV) || isOpenDebugMode;

/** 启用 Sentry 开发环境不启用 */
export const SENTRY_ENABLE = !DEV_MODE;

const ENV = ENV_CONFIG[A1_BUILD_ENV as DeployEnvironment];

// 注释: 新版本 App 注入了 supportNewDomain 方法，使用新 CDN；旧版本 App 用旧 CDN
const isSupportNewHost = !!(
	window.AndroidInterface && typeof (window.AndroidInterface as any).supportNewDomain === 'function'
);
const MATRIX_CDN_HOST = (matrixAssets as any)?.text?.CDN_HOST;

export const A1_STATIC_URL =
	isSupportNewHost && MATRIX_CDN_HOST && isProd ? `https://${MATRIX_CDN_HOST}` : ENV.A1_STATIC_URL;

export const { GOOGLE_CLIENT_ID, A1_DATA_WAREHOUSE, FACEBOOK_APP_ID, CLOUD_CTRL_FALLBACK_URL } =
	ENV;
export const A1_JS_URL = window.location.origin;
export const A1_SOCKET_URL =
	DEV_MODE || A1_LOCAL ? A1_LOCAL_SOCKET_URL || ENV.A1_SOCKET_URL : `wss://${window.location.host}`;
export const A1_SERVER_URL = A1_LOCAL_SERVER_URL ? A1_LOCAL_SERVER_URL : ENV.A1_SERVER_URL;
export const __DEV_MODE__ = localStorage.getItem('A1_DEV_MODE') === '1';
